import { render, staticRenderFns } from "./StorageSettings.vue?vue&type=template&id=042a1de9"
import script from "./StorageSettings.vue?vue&type=script&lang=js"
export * from "./StorageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports